import TypeError from '.TypeError';

import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';

export default class TypeSelector extends Layer       {
	
	elementNameLiteral        ;
	namespaceLiteral               ;
	
	constructor (elementNameLiteral        , namespaceLiteral                = null) {
		//if ( !elementNameLiteral ) { throw SyntaxError(`Type Selector 不能为 ${namespaceLiteral}`); }
		super();
		TOKEN.currentLayer && ( TOKEN.collection_type[TOKEN.collection_type.length] = this );
		this.elementNameLiteral = elementNameLiteral;
		this.namespaceLiteral = namespaceLiteral;
		return this;
	}
	
	[TOKEN.consume] (                  )        { throw TypeError(`typeSelector[consume]`); }
	
	get literal () { return this.namespaceLiteral===null ? this.elementNameLiteral : `${this.namespaceLiteral}|${this.elementNameLiteral}`; }
	
	[Symbol.toPrimitive] (                  ) { return this.literal; }
	
	* [Symbol.iterator] (                  ) { throw TypeError(`beautify typeSelector`); }
	
	static default = protect(this);
	
};
